import { render } from "./StudentPassHistory.vue?vue&type=template&id=a80af22c"
import script from "./StudentPassHistory.vue?vue&type=script&lang=js"
export * from "./StudentPassHistory.vue?vue&type=script&lang=js"

import "./StudentPassHistory.vue?vue&type=style&index=0&id=a80af22c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__